import React from "react";
import { MapPin, Phone, Mail, Facebook, Instagram } from "lucide-react";
import { useLang } from "@/App";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-blue-950 text-slate-200 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2">
          <img
            src="https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/vici73nm_AMPLISOON.png"
            alt="Amplisoon Centro Audiológico"
            className="h-16 w-auto rounded-lg"
            data-testid="footer-logo"
          />
          <p className="mt-5 text-base text-slate-300 max-w-md leading-relaxed">
            {t.footer.tagline}
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="grid place-items-center w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 transition-colors"
              data-testid="social-facebook"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="grid place-items-center w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 transition-colors"
              data-testid="social-instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <div className="text-sm font-bold uppercase tracking-widest text-sky-200">
            {t.nav.contact}
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex gap-2.5 items-start">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-sky-300" />
              <span>
                {t.contact.info.address}
                <span className="block text-sky-300 mt-1">{t.contact.info.addressReference}</span>
              </span>
            </li>
            <li className="flex gap-2.5 items-start">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-sky-300" />
              <span>
                {t.contact.info.address2}
                <span className="block text-sky-300 mt-1">{t.contact.info.address2Reference}</span>
              </span>
            </li>
            <li className="flex gap-2.5 items-start">
              <Phone className="w-4 h-4 mt-0.5 shrink-0 text-sky-300" />
              <span>{t.contact.info.phones}</span>
            </li>
            <li className="flex gap-2.5 items-start">
              <Mail className="w-4 h-4 mt-0.5 shrink-0 text-sky-300" />
              <a href="mailto:audifonosamplisoon@gmail.com" className="hover:text-white break-all">
                audifonosamplisoon@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-bold uppercase tracking-widest text-sky-200">
            {t.contact.info.hours}
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <div className="font-semibold text-sky-200">{t.contact.info.hoursCampelloLabel}</div>
              <ul className="mt-1 space-y-0.5">
                {t.contact.info.hoursCampello.map((h, i) => (
                  <li key={i}>{h}</li>
                ))}
              </ul>
            </li>
            <li>
              <div className="font-semibold text-sky-200">{t.contact.info.hoursTorrellanoLabel}</div>
              <ul className="mt-1 space-y-0.5">
                {t.contact.info.hoursTorrellano.map((h, i) => (
                  <li key={i}>{h}</li>
                ))}
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12 flex flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs uppercase tracking-widest text-sky-200/70 font-semibold">Desarrollado por</span>
          <img
            src="https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/yx7m227s_RL%20Impulsa%20s_fondo.png"
            alt="RL Impulsa"
            className="h-28 md:h-32 w-auto"
            data-testid="rl-impulsa-logo"
          />
        </div>
        <div className="w-full flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-slate-400">
          <div>
            © {new Date().getFullYear()} Amplisoon Centro Audiológico. {t.footer.rights}
          </div>
          <div>{t.footer.privacy}</div>
        </div>
      </div>
    </footer>
  );
}
